import { Link } from "react-router-dom";
import { ShieldCheck, Phone, Mail, MapPin, Clock, Facebook, Instagram, Linkedin } from "lucide-react";
import { CONTACT } from "../lib/contact";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-slate-800 bg-slate-950">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-5 gap-8">
        <div className="md:col-span-2">
          <img src="/logo.png" alt="Integrity Delivered" data-testid="footer-logo" className="h-16 w-auto mb-4 drop-shadow-[0_2px_8px_rgba(0,0,0,0.6)]" />
          <p className="text-sm text-slate-400 leading-relaxed max-w-md">
            An independent delivery service company operating under contract with FedEx Ground, proudly serving the Greater Baltimore area.
          </p>
          <div className="mt-4 flex items-center gap-2 text-xs text-slate-500 uppercase tracking-widest">
            <ShieldCheck className="w-3 h-3" /> Independent Contractor · Not FedEx Corporation
          </div>
          <div className="mt-5 flex items-center gap-2">
            {[
              { id: "facebook", Icon: Facebook, href: CONTACT.facebook },
              { id: "instagram", Icon: Instagram, href: CONTACT.instagram },
              { id: "linkedin", Icon: Linkedin, href: CONTACT.linkedin },
            ].map((s) => (
              <a key={s.id} data-testid={`footer-social-${s.id}`} href={s.href} target="_blank" rel="noreferrer" className="w-9 h-9 rounded-full border border-slate-700 flex items-center justify-center text-slate-300 hover:text-amber-400 hover:border-amber-500/60 transition-colors">
                <s.Icon className="w-4 h-4" />
              </a>
            ))}
          </div>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-slate-500 mb-3">Contact</div>
          <ul className="space-y-2 text-sm text-slate-300">
            <li className="flex items-center gap-2"><Phone className="w-3.5 h-3.5 text-amber-400" /><a data-testid="footer-phone" href={`tel:${CONTACT.phoneRaw}`} className="hover:text-amber-400">{CONTACT.phone}</a></li>
            <li className="flex items-center gap-2"><Mail className="w-3.5 h-3.5 text-amber-400" /><a data-testid="footer-email" href={`mailto:${CONTACT.email}`} className="hover:text-amber-400 break-all">{CONTACT.email}</a></li>
            <li className="flex items-center gap-2"><MapPin className="w-3.5 h-3.5 text-amber-400" />{CONTACT.location}</li>
            <li className="flex items-center gap-2"><Clock className="w-3.5 h-3.5 text-amber-400" />{CONTACT.hours}</li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-slate-500 mb-3">Explore</div>
          <ul className="space-y-2 text-sm text-slate-300">
            <li><Link to="/careers" className="hover:text-amber-400">Careers</Link></li>
            <li><Link to="/driver-of-the-week" className="hover:text-amber-400">Driver of the Week</Link></li>
            <li><Link to="/about" className="hover:text-amber-400">About Us</Link></li>
            <li><Link to="/contact" className="hover:text-amber-400">Contact</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-slate-500 mb-3">Legal</div>
          <p className="text-xs text-slate-400 leading-relaxed">
            Integrity Delivered, Inc. is an Equal Opportunity Employer. FedEx and related marks are trademarks of FedEx Corporation, referenced here solely to identify our service relationship.
          </p>
        </div>
      </div>
      <div className="border-t border-slate-900 py-4 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} Integrity Delivered, Inc. All rights reserved.
      </div>
    </footer>
  );
}
